import React from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { IconChevronDown } from '../Icon';
import { Icon, Option, Select, Wrapper } from './wrapper';

export interface OptionProps {
  value?: number | string;
  displayName?: number | string | null;
  disabled?: boolean;
}

export interface Props {
  value?: string | number;
  defaultValue?: string | number;
  options?: OptionProps[];
  defaultOption?: OptionProps;
  unit?: string;
  id?: string;
  name?: string;
  title: string;
  disabled?: boolean;
  register?: UseFormRegisterReturn;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const InputSelect = ({
  disabled,
  value,
  defaultValue,
  options,
  onChange,
  unit,
  id,
  name,
  title,
  defaultOption,
  register,
}: Props) => (
  <Wrapper>
    <Select
      disabled={disabled}
      value={value}
      onChange={onChange}
      title={title}
      aria-label={title}
      id={id}
      name={name}
      defaultValue={defaultValue}
      {...register}
    >
      {defaultOption && (
        <Option
          key={defaultOption.value}
          value={defaultOption.value}
          disabled={defaultOption.disabled}
        >
          {defaultOption.displayName}
        </Option>
      )}
      {options?.map((option, index) => (
        <Option
          key={`${option.value}-${index}`}
          value={option.value || ''}
          disabled={option.disabled}
        >
          {option.displayName || option.value}
          {unit ? ` ${unit}` : ''}
        </Option>
      ))}
    </Select>
    <Icon>
      <IconChevronDown />
    </Icon>
  </Wrapper>
);

export default InputSelect;
